// src/components/register/components/RegisterForm.jsx

import React, { useState } from 'react';
import { Spin } from 'antd';
import Input from '../../shared/Inputs';
import Buttons from '../../shared/buttons';
import PeiixMaster from '../../../img/Peiixmasterlogo.png';
import '../Styles/Register.css';

const RegisterForm = ({
    formData,
    currentStep = 1,
    nextStep,
    prevStep,
    loading,
    message,
    error,
    handleChange,
    handleSubmit,
    handleGoToLogin
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    return (
        <form onSubmit={handleSubmit} className="register-form">

            <img src={PeiixMaster} alt="Peiix Master" className="logotipo" />

            <div className="register-title">
                Crear Cuenta
            </div>

            {/* Indicador de pasos */}
            <div className="register-steps-indicator">
                <div className={`step-item ${currentStep === 1 ? 'active' : 'completed'}`}>
                    <span className="step-circle">{currentStep > 1 ? '✓' : '1'}</span>
                    <span className="step-title">Datos Personales</span>
                </div>
                <div className={`step-line ${currentStep > 1 ? 'completed' : ''}`} />
                <div className={`step-item ${currentStep === 2 ? 'active' : ''}`}>
                    <span className="step-circle">2</span>
                    <span className="step-title">Documentación</span>
                </div>
            </div>

            {/* PASO 1: Datos Personales y del Comercio */}
            {currentStep === 1 && (
                <>
                    <Input
                        label="Nombre del comercio"
                        type="text"
                        name="commerceName"
                        value={formData.commerceName}
                        onChange={handleChange}
                        placeholder="Introduzca el nombre de su comercio"
                        className="register-input"
                        required
                    />
                    <Input
                        label="Nombre"
                        type="text"
                        name="customerName"
                        value={formData.customerName}
                        onChange={handleChange}
                        placeholder="Introduzca su nombre"
                        className="register-input"
                        required
                    />
                    <Input
                        label="Apellido Paterno"
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        placeholder="Introduzca su apellido paterno"
                        className="register-input"
                        required
                    />
                    <Input
                        label="Apellido Materno"
                        type="text"
                        name="lastName2"
                        value={formData.lastName2}
                        onChange={handleChange}
                        placeholder="Introduzca su apellido materno"
                        className="register-input"
                        required
                    />
                    <Input
                        label="Correo Electrónico"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Introduzca su correo"
                        className="register-input"
                        required
                    />
                    <div className="input-group">
                        <label htmlFor="password">Contraseña</label>
                        <div className="password-input-container">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Cree su contraseña"
                                className="register-input"
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                            >
                                <i className={`bi bi-${showPassword ? 'eye-slash' : 'eye'}`}></i>
                            </button>
                        </div>
                    </div>
                    {formData.password.length > 0 && (
                        <div className="password-hints">
                            <span className={`password-hint-item ${formData.password.length >= 8 ? 'met' : ''}`}>
                                {formData.password.length >= 8 ? '✓' : '✗'} Mínimo 8 caracteres
                            </span>
                            <span className={`password-hint-item ${/[A-Z]/.test(formData.password) ? 'met' : ''}`}>
                                {/[A-Z]/.test(formData.password) ? '✓' : '✗'} Al menos 1 mayúscula
                            </span>
                            <span className={`password-hint-item ${/[0-9]/.test(formData.password) ? 'met' : ''}`}>
                                {/[0-9]/.test(formData.password) ? '✓' : '✗'} Al menos 1 número
                            </span>
                        </div>
                    )}
                    <div className="input-group">
                        <label htmlFor="confirmPassword">Confirmar contraseña</label>
                        <div className="password-input-container">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirmPassword"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="Confirme su contraseña"
                                className="register-input"
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                aria-label={showConfirmPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                title={showConfirmPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                            >
                                <i className={`bi bi-${showConfirmPassword ? 'eye-slash' : 'eye'}`}></i>
                            </button>
                        </div>
                    </div>
                    <Input
                        label="Dirección"
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Introduzca su dirección completa"
                        className="register-input"
                        required
                    />
                    <Input
                        label="Teléfono"
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Introduzca su número de teléfono"
                        className="register-input"
                        required
                    />

                    {message && (
                        <div style={{ color: error ? '#dc2626' : '#0E9600', marginTop: '0.8rem', width: '100%', textAlign: 'left', fontWeight: '500' }}>
                            {message}
                        </div>
                    )}

                    <button type="button" className="register-btn" onClick={nextStep}>
                        Continuar a Documentos →
                    </button>
                </>
            )}

            {/* PASO 2: Documentación y Validación */}
            {currentStep === 2 && (
                <>
                    <p className="register-step-description">
                        Adjunte los siguientes documentos en formato imagen para validar y activar su cuenta.
                    </p>

                    <div className="input-group-register">
                        <label htmlFor="ine">Foto de tu INE (Parte delantera)</label>
                        <input
                            type="file"
                            id="ine"
                            name="ine"
                            accept="image/*"
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="input-group-register">
                        <label htmlFor="ineback">Foto de tu INE (Parte trasera)</label>
                        <input
                            type="file"
                            id="ineback"
                            name="ineback"
                            accept="image/*"
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="input-group-register">
                        <label htmlFor="face">Foto de tu rostro (Selfie)</label>
                        <input
                            type="file"
                            id="face"
                            name="face"
                            accept="image/*"
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="input-group-register">
                        <label htmlFor="proofOfAddress">Comprobante de domicilio (reciente)</label>
                        <input
                            type="file"
                            id="proofOfAddress"
                            name="proofOfAddress"
                            accept="image/*"
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="input-group-register">
                        <label htmlFor="clabe">Cuenta CLABE para depósitos (Comprobante o carátula)</label>
                        <input
                            type="file"
                            id="clabe"
                            name="clabe"
                            accept="image/*"
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {message && (
                        <div style={{ color: error ? '#dc2626' : '#0E9600', marginTop: '0.8rem', width: '100%', textAlign: 'left', fontWeight: '500' }}>
                            {message}
                        </div>
                    )}

                    <div className="register-buttons-group">
                        <button type="button" className="register-btn-secondary" onClick={prevStep} disabled={loading}>
                            ← Volver
                        </button>
                        <Buttons type="submit" className="register-btn register-btn-submit" disabled={loading}>
                            {loading ? <Spin /> : 'Completar Registro'}
                        </Buttons>
                    </div>
                </>
            )}

            <a href="/Inicio" onClick={handleGoToLogin} className="register-link">¿Ya tienes cuenta? Inicia Sesión</a>

        </form>
    );
};

export default RegisterForm;